import React, { useEffect, useState } from "react";
import { userRequest } from "../request";
import { useSelector } from "react-redux";
import ProjectCard from "./ProjectCard";
import { IoSearch } from "react-icons/io5";
import { BsFilterLeft } from "react-icons/bs";

const ProjectList = () => {
  const user = useSelector((state) => state.user.user);
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("name");
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const itemsPerPage = 10;

  const getProjects = async () => {
    const response = await userRequest(user.token).get("/project");
    setProjects(response.data);
    setFilteredProjects(response.data);
    console.log(response.data);
  };

  const handleUpdate = (updatedProject) => {
    setProjects((prevProjects) =>
      prevProjects.map((project) =>
        project._id === updatedProject._id ? updatedProject : project
      )
    );
    getProjects();
  };

  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    handleFilterAndSearch();
  }, [searchQuery, filter, currentPage]);

  const handleFilterAndSearch = () => {
    let filtered = projects;

    // Search functionality
    if (searchQuery) {
      filtered = filtered.filter((project) =>
        Object.values(project).some((value) =>
          value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    // Filter functionality
    if (filter) {
      filtered = filtered.sort((a, b) => {
        if (a[filter] < b[filter]) return -1;
        if (a[filter] > b[filter]) return 1;
        return 0;
      });
    }

    setFilteredProjects(filtered);
  };

  // Pagination functionality
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProjects.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);

  return (
    <div className="projectlist max-w-max pb-20 flex flex-col lg:bg-white lg:rounded-2xl lg:shadow-lg gap-4">
      <div className="search flex justify-between p-4">
        <div className="flex gap-2 border-b border-black p-2">
          <IoSearch className="text-xl" />
          <input
            type="text"
            className="outline-none"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <BsFilterLeft
          className="lg:hidden text-2xl cursor-pointer"
          onClick={() => setShowFilterOptions(!showFilterOptions)}
        />
        <div className="hidden lg:block">
          Sort by:
          <select
            name="filter"
            id="filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="name">Project Name</option>
            <option value="reason">Reason</option>
            <option value="type">Type</option>
            <option value="division">Division</option>
            <option value="category">Category</option>
            <option value="priority">Priority</option>
            <option value="dept">Dept.</option>
            <option value="location">Location</option>
            <option value="status">Status</option>
          </select>
        </div>
      </div>
      {showFilterOptions && (
        <div className="lg:hidden flex justify-center p-4">
          Sort by:
          <select
            name="filter"
            id="filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="name">Project Name</option>
            <option value="reason">Reason</option>
            <option value="type">Type</option>
            <option value="division">Division</option>
            <option value="category">Category</option>
            <option value="priority">Priority</option>
            <option value="dept">Dept.</option>
            <option value="location">Location</option>
            <option value="status">Status</option>
          </select>
        </div>
      )}
      <div className="headers hidden lg:block lg:grid grid-cols-12 gap-6 bg-sky-50 py-4 font-bold p-4">
        <div className="col-span-2">Project Name</div>
        <div className="col-span-1">Reason</div>
        <div className="col-span-1">Type</div>
        <div className="col-span-1">Division</div>
        <div className="col-span-1">Category</div>
        <div className="col-span-1">Priority</div>
        <div className="col-span-1">Dept.</div>
        <div className="col-span-1">Location</div>
        <div className="col-span-1 font-bold text-sky-900">Status</div>
        <div className="col-span-2 flex items-center gap-2"></div>
      </div>
      <div className="list">
        {currentItems.map((project, index) => (
          <ProjectCard project={project} onUpdate={handleUpdate} key={index} />
        ))}
      </div>
      <div className="pagination flex justify-center mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className="mx-4">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ProjectList;
